import React from 'react';
import { Subscribe } from 'unstated';
import { RouteComponentProps } from 'react-router-dom';
import SimpleChoiceContainer from '../../state/containers/SimpleChoiceContainer';
import ApplicationContainer from '../../state/containers/ApplicationContainer';
import TitleStateContainer from '../../state/containers/TitleStateContainer';
import RepromptContainer from '../../state/containers/RepromptContainer';
import FollowUpContainer from '../../state/containers/FollowUpContainer';
import MediaResponseStateContainer from '../../state/containers/MediaResponseContainer';
import EditSimpleChoiceForm from './components/EditSimpleChoiceForm';
import NavigationBarFormPage from '../formScenes/NavigationBarFormPage';
import ConversationNavigationState from '../../models/state/ConversationNavigationState';
import SimpleChoiceModel from '../../models/features/api/SimpleChoices/SimpleChoiceModel';
import IResult from '../../models/result/IResult';
import GenericEditContentItemPage from '../formScenes/GenericEditContentItemPage';
import FeatureContainer from '../../state/containers/FeatureContainer';
import { SimpleChoiceFeatureTypeId } from '../../constants/featureTypeIds';
import queryString from 'query-string';
import ApplicationEnvironmentsContainer from '../../state/containers/ApplicationEnvironmentsContainer';
import ApplicationBackupVersionsContainer from '../../state/containers/ApplicationBackupVersionsContainer';

interface ApplicationRouteProps {
    applicationFeatureId: string
    simpleChoiceId: string
}
interface EditSimpleChoiceProps extends RouteComponentProps<ApplicationRouteProps> { }

class EditSimpleChoices extends React.Component<EditSimpleChoiceProps> {
    render() {
        return (
            <Subscribe key={this.props.match.params.simpleChoiceId + this.props.match.params.applicationFeatureId} to={[
                SimpleChoiceContainer,
                ApplicationContainer,
                TitleStateContainer,
                RepromptContainer,
                FollowUpContainer,
                MediaResponseStateContainer,
                FeatureContainer,
                ApplicationEnvironmentsContainer,
                ApplicationBackupVersionsContainer]}>
                {(simpleChoiceContainer: SimpleChoiceContainer,
                    appContainer: ApplicationContainer,
                    titleContainer: TitleStateContainer,
                    repromptContainer: RepromptContainer,
                    followUpContainer: FollowUpContainer,
                    responseContainer: MediaResponseStateContainer,
                    featureContainer: FeatureContainer,
                    environmentsContainer: ApplicationEnvironmentsContainer,
                    backupsContainer: ApplicationBackupVersionsContainer) => {
                    return (
                        <GenericEditContentItemPage stateContainer={simpleChoiceContainer}
                            environmentsContainer={environmentsContainer}
                            backupsContainer={backupsContainer}
                            titleContainer={titleContainer}
                            applicationContainer={appContainer}
                            defaultTitle="Edit Simple Choice"
                            contentItemId={this.props.match.params.simpleChoiceId}
                            history={this.props.history}
                            location={this.props.location}
                            match={this.props.match}
                            staticContext={this.props.staticContext}
                            featureContainer={featureContainer}
                            featureTypeId={SimpleChoiceFeatureTypeId}
                            formRender={(contentItem: SimpleChoiceModel,
                                application,
                                isTemplateOwned,
                                assistantApplication,
                                onShowPublishModal,
                                onSubmit: (model: SimpleChoiceModel, onSuccess) => Promise<IResult<SimpleChoiceModel>>,
                                toggleSync: (id, shouldNotSync) => Promise<IResult<SimpleChoiceModel>>,
                                onAccessTypeChange) => (
                                <EditSimpleChoiceForm
                                    location={this.props.location}
                                    applicationFeatureId={this.props.match.params.applicationFeatureId}
                                    application={application}
                                    simpleChoice={contentItem}
                                    stateContainer={simpleChoiceContainer}
                                    repromptContainer={repromptContainer}
                                    followUpContainer={followUpContainer}
                                    appContainer={appContainer}
                                    responseStateContainer={responseContainer}
                                    featureContainer={featureContainer}
                                    assistantApplication={assistantApplication}
                                    onShowPublishModal={onShowPublishModal}
                                    onAccessTypeChange={onAccessTypeChange}
                                    onSubmit={onSubmit}
                                    onToggleSync={toggleSync}
                                    previousContentId={queryString?.parse(this.props.location.search)?.previousContentId as string}
                                    history={this.props.history}
                                    isSaving={simpleChoiceContainer.state.isSaving}
                                    isTemplateOwned={isTemplateOwned} />
                            )} />
                    );
                }}
            </Subscribe>
        );
    }
}

export default EditSimpleChoices;